import { render, staticRenderFns } from "./Exception08.vue?vue&type=template&id=20af9925&scoped=true"
import script from "./Exception08.vue?vue&type=script&lang=js"
export * from "./Exception08.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20af9925",
  null
  
)

export default component.exports